import { useMutation, useQueryClient } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import type { ParentDetails } from '../model/parent.type';

interface DeleteParentParams {
  parentId: string;
}

export const deleteParentAPI = async (params: DeleteParentParams) => {
  const response = await baseAPI.delete<ParentDetails>(
    `/parents/${params.parentId}`,
  );
  return response.data;
};

export const useDeleteParent = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (params: DeleteParentParams) => deleteParentAPI(params),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.PARENTS_LIST, KEYS.STUDIO],
      });
    },
  });
};
